<template>
  <div class="spaceViewPage"></div>
</template>
<script>
import * as THREE from 'three'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader'
import * as api from '../service/getData'
import UploadFile from '../plugins/upload/upload'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader'

export default {
  name: 'GltfView',
  data () {
    return {
      scene: '',
      light: '',
      camera: '',
      controls: '',
      renderer: '',
      mixer: null,
      currpivot: null
    }
  },
  props: ['uploadFinish', 'address'],
  mounted () {
    this.createScene()
    this.render()
    window.that = this
  },
  components: {},
  created () {
  },
  methods: {
    // 初始化three.js相关内容
    createScene () {
      const container = document.querySelector('.spaceViewPage')
      this.renderer = new THREE.WebGLRenderer({antialias: true, preserveDrawingBuffer: true})
      this.renderer.setSize(container.offsetWidth, container.offsetHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.physicallyCorrectLights = true
      this.renderer.shadowMap.enabled = true
      this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
      this.renderer.toneMapping = THREE.ReinhardToneMapping
      this.renderer.outputEncoding = THREE.sRGBEncoding
      // 色调映射的曝光级别。默认是1,曝光度值越大，图像亮度越高
      // 可以尝试不同值去测试显示效果 比如0:看不到  0.1:很暗  200:过于亮，轮廓感不清楚
      this.renderer.toneMappingExposure = 2
      // 是否乘以gamma输出，默认值false
      this.renderer.gammaOutput = true
      this.renderer.gammaFactor = 2.2

      this.camera = new THREE.PerspectiveCamera(
        60,
        container.offsetWidth / container.offsetHeight,
        0.1,
        5000
      )

      new RGBELoader()

        .setDataType(THREE.HalfFloatType)

        .load('https://jojoworld-1323727948.cos.ap-singapore.myqcloud.com/venice_sunset_05K.hdr', t => {
          t.mapping = THREE.EquirectangularReflectionMapping

          // this.scene.background = t

          this.scene.environment = t
        })

      this.camera.position.set(0, 2, 70)
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color('#E6E6E6')
      this.createLights()
      container.appendChild(this.renderer.domElement)
      const controls = new OrbitControls(this.camera, this.renderer.domElement)
      // controls.target.set(0, 0, 0)
      controls.update()
    },
    createLights () {
      var ambientLight = new THREE.AmbientLight(0xffffff, 5)
      this.scene.add(ambientLight)
    },

    onResize () {
      const container = document.querySelector('.spaceViewPage')
      const w = container.offsetWidth
      const h = container.offsetHeight
      this.camera.aspect = w / h
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(w, h)
    },
    createFileObjects (file) {
      const url = URL.createObjectURL(file)
      this.createObjects(url, () => {
        URL.revokeObjectURL(url)
      })
    },
    createObjects (link, callback) {
      if (this.currpivot != null) {
        this.scene.remove(this.currpivot)
      }
      const loader = new GLTFLoader()
      const dracoLoader = new DRACOLoader()
      dracoLoader.setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.155.0/examples/jsm/libs/draco/')
      dracoLoader.setDecoderConfig({type: 'js'})
      loader.setDRACOLoader(dracoLoader)
      loader.load(link,
        (gltf) => {
          let mesh = gltf.scene
          // this.scene.add(mesh);
          // gltf.scene.scale.set(10,10,10)
          gltf.scene.scale.set(8, 8, 8)
          this.scene.add(gltf.scene)
          if (callback) {
            callback()
          }
          var box = new THREE.Box3().setFromObject(mesh)
          let height = box.max.x - box.min.z
          var dist = height / (2 * Math.tan(this.camera.fov * Math.PI / 360))
          this.camera.position.set(0, 2, dist * 1.8)
          // box.center(mesh.position);
          mesh.position.multiplyScalar(-1)
          var pivot = new THREE.Group()
          this.currpivot = pivot
          this.scene.add(pivot)
          pivot.add(mesh)
          if (this.uploadFinish) {
            setTimeout(() => {
              this.dealImg()
            }, 1000)
          }
        }
      )
    },
    async dealImg () {
      let canvas = this.renderer.domElement
      this.uploadFinish(this.dataURItoBlob(canvas.toDataURL('image/png')))
    },
    dataURItoBlob (base64Data) {
      var byteString
      if (base64Data.split(',')[0].indexOf('base64') >= 0) { byteString = atob(base64Data.split(',')[1]) } else { byteString = unescape(base64Data.split(',')[1]) }
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], {type: mimeString})
    },
    render () {
      this.renderer.render(this.scene, this.camera)
      this.reqAnimation = window.requestAnimationFrame(this.render)
    }
  }
}
</script>

<style lang="less">
.spaceViewPage {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/GltfView.vue